import React from 'react';
import "./nav.css";
import { Notification } from 'iconsax-react';
import ava from "../../assets/profile-avatar.png";
import wave from "../../assets/wave.png";

const TopBar = () => {

  const userData = JSON.parse(localStorage?.getItem("apk"))?.data;
  
  

  return (
    <div className='top-bar'>
      <div className="top-bar_text">
        <h3>Hey, {userData?.developerName || userData?.agencyName } <img src={wave} alt="wave" /> </h3>
        <h3>Id: {userData?.developerId || userData?.agentId}</h3>
        <p>Here’s what is happening in your workplace</p>
      </div>
      <div className="top-bar_ava">
        <Notification size={24} color='#848484' />
        <img src={ava} alt="avatar" />
      </div>
    </div>
  )
}

export default TopBar